import { render, staticRenderFns } from "./VlBottomActionsButton.vue?vue&type=template&id=0ef12858&scoped=true&"
import script from "./VlBottomActionsButton.vue?vue&type=script&lang=js&"
export * from "./VlBottomActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef12858",
  null
  
)

export default component.exports